import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { GetInconsistenciesResponse } from '@/api/types/queries';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';
import { InconsistencyFilters } from '@/types';

export const useGetInconsistencies = ({
  caseId,
  page,
  pageSize,
  filters,
  searchQuery,
}: {
  caseId: string | null;
  page: number;
  pageSize: number;
  filters: InconsistencyFilters;
  searchQuery?: string;
}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      page: page,
      pageSize: pageSize,
      searchQuery: searchQuery || '',
      ...createFilterBody(filters),
    },
  });

  return useQuery<GetInconsistenciesResponse>(
    [QueryEntity.CaseInconsistencies, { caseId }, { filters, page, pageSize, searchQuery }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}/inconsistency/query`, {
        ...fetchConfigPOST,
      });
      return res.json();
    },
    { refetchOnWindowFocus: false },
  );
};
